module.exports = __webpack_public_path__ + "img/XC0703.d5e27c81.png";